// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1Yvkj","label":"Labeled_label__2xfOO","divider":"Labeled_divider__l9Qlx"};